import { render, staticRenderFns } from "./logoBlack.vue?vue&type=template&id=7c3777d8&"
import script from "./logoBlack.vue?vue&type=script&lang=js&"
export * from "./logoBlack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports